export class ClassRequestModel {
  classId: number;
  subjectId?: number;
  constructor(classId: number, subjectId?: number) {
    this.classId = classId;
    this.subjectId = subjectId;
  }
}
